<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="title"
            placeholder="请输入名称"
          />
        </a-form-item>
        <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
          <a-textarea
            rows="2"
            name="lable"
            placeholder="请输入标签"
            v-decorator="['lable', { rules: [{ required: true, message: '请输入目标描述' }] }]"
          />
        </a-form-item>
        <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="selectLoading">
            <a-select
              placeholder="请选择分类"
              style="width: 100%"
              name="category"
              optionFilterProp="children"
              allow-clear
              v-decorator="['category', { rules: [{ required: true, message: '请选择分类' }] }]"
            >
              <a-select-option v-for="d in selectList" :key="d.id">{{ d.title }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="缩略图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img-upload
            name="thum"
            v-decorator="['thum', { rules: [{ required: true, message: '请上传新闻缩略图' }] }]"
          />
        </a-form-item>
        <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
          <u-editor
            name="content"
            v-decorator="['content', { rules: [{ required: true, message: '请输入文章内容' }] }]"
          />
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
          <a-input-number
            name="order"
            v-decorator="[
              'order',
              {
                initialValue: 0
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button
            :loading="formLoading"
            type="primary"
            @click="handleSubmit(setFormData)"
          >提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { ImgUpload, UEditor, GoBack } from '@/components'
import { form, select } from '@/mixins'
const fields = ['lable', 'category', 'desc', 'thum', 'date', 'content', 'state', 'order', 'title']
const apiList = {
    getInfo: '/news/',
    create: '/news/create',
    update: '/news/',
    selectList: '/news/categories/select'
}
export default {
    name: 'NewsForm',
    mixins: [form, select],
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            selectLoading: false, // 分类下拉加载
            selectList: [] // 分类下拉数据
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.date = that.moment(values.date) // 日期格式转换
                values.state = values.state === 1 // 状态格式转换
            }) // 获取编辑信息
        }
        that.getSelectLists({
            url: apiList.selectList
        }) // 获取下拉分类列表
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-25 16:14:35
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.date = this.moment(values.date).format('YYYY-MM-DD') // 日期格式转换
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
        }
    }
}
</script>
